import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPaymentinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zM1 4v2h14V4H1zm10 7v1h3v-1h-3z",
		fill: "currentColor",
		fillRule: "evenodd"
	})
});
export default SvgPaymentinline;
